import { render, staticRenderFns } from "./DangerCard.vue?vue&type=template&id=8ee7ae0a&scoped=true&"
import script from "./DangerCard.vue?vue&type=script&lang=js&"
export * from "./DangerCard.vue?vue&type=script&lang=js&"
import style0 from "./DangerCard.vue?vue&type=style&index=0&id=8ee7ae0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee7ae0a",
  null
  
)

export default component.exports